import { swiper } from "./swiper";
import { swiperThumbs } from "./swiper-thumbs";

const imageWrappers = document.querySelectorAll(".screenshot-grid__img-wrapper");
const popup = document.querySelector(".carousel-popup");
const playButtons = document.querySelectorAll(".js-play-video");
const videos = document.querySelectorAll(".carousel-popup__video");
const iframes = document.querySelectorAll('.video-player');
const close = document.querySelector(".screenshot-carousel__btn-close");

if (imageWrappers && popup) {
  imageWrappers.forEach((wrapper, index) => {
    wrapper.addEventListener("click", () => {
      popup.showModal();
      swiper.slideTo(index);
      swiperThumbs.slideTo(index);
      document.body.classList.add("modal-open");
    });
  });
}

if (close) {
  close.addEventListener("click", () => {
    popup.close();
  });
}

if (popup) {
  popup.addEventListener("close", () => {
    document.body.classList.remove("modal-open");

    if (videos && playButtons) {
      videos.forEach((video, index) => {
        video.pause();
        video.controls = false;
        playButtons[index].style.visibility = "visible";
      });
    }

    if (iframes) {
      iframes.forEach(iframe => {
        iframe.contentWindow.postMessage('{"event":"command","func":"pauseVideo","args":""}', '*');
      });
    }
  });
}

if (playButtons && videos) {
  playButtons.forEach((button, index) => {
    button.addEventListener("click", () => {
      videos[index].play();
      videos[index].controls = true;
      button.style.visibility = "hidden";
    });
  });
}